<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="add()"
      >添加</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 230px )"
      size="mini"
    >
      <el-table-column prop="id" label="菜单ID" width="80" />
      <el-table-column
        prop="menuName"
        label="菜单名称"
        :show-overflow-tooltip="true"
        width="160"
      />
      <el-table-column
        prop="menuType"
        label="菜单类型"
        :show-overflow-tooltip="true"
        width="100"
      />
      <el-table-column prop="parentId" label="上级菜单" width="80" />
      <el-table-column prop="orderNum" label="排序" width="80" />
      <el-table-column
        prop="menuIcon"
        label="图标"
        align="center"
        width="200"
      />

      <el-table-column
        prop="permis"
        label="权限标识"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        prop="menuPath"
        label="组件路径"
        :show-overflow-tooltip="true"
      />
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <span
            :style="scope.row.status === 1 ? 'color:#00c759' : 'color:red'"
          >{{ scope.row.status === 1 ? "正常" : "已禁用" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createdAt" />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="560px"
      :close-on-click-modal="false"
      :title="Isedit ? '编辑' : '添加'"
      @close="handleClose"
    >
      <div class="edit_titile">
        <el-form ref="form" :model="formData" label-width="80px">
          <el-form-item label="菜单名称">
            <el-input
              v-model="formData.menuName"
              placeholder="请输入角色名称"
            />
          </el-form-item>
          <el-form-item label="菜单图标">
            <el-input
              v-model="formData.menuIcon"
              placeholder="请输入菜单图标路径"
            />
          </el-form-item>
          <el-form-item label="菜单排序">
            <el-input
              v-model="formData.orderNum"
              placeholder="请输入菜单排序"
            />
          </el-form-item>
          <el-form-item label="权限标识">
            <el-input v-model="formData.permis" placeholder="请输入权限标识" />
          </el-form-item>
          <el-form-item label="菜单类型">
            <el-select v-model="formData.menuType" placeholder="请选择活动区域">
              <el-option label="根目录" value="M" />
              <el-option label="子菜单" value="C" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData.menuType === 'C'" label="上级菜单">
            <el-select v-model="formData.parentId" placeholder="请选择活动区域">
              <el-option
                v-for="(item, i) in routerOption"
                :key="i"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="组件路径">
            <el-input
              v-model="formData.menuPath"
              placeholder="请输入组件路径"
            />
          </el-form-item>
          <el-form-item label="菜单状态">
            <el-select v-model="formData.status" placeholder="请选择菜单状态">
              <el-option label="正常" value="1" />
              <el-option label="禁用" value="0" />
            </el-select>
          </el-form-item>
          <!-- 弹窗脚部 -->
          <el-form-item>
            <el-button @click="edit_dialogVisible = false">取 消</el-button>
            <el-popconfirm
              :title="'确定' + `${Isedit ? '修改' : '添加'}` + '吗？'"
              @onConfirm="submitForm()"
            >
              <el-button
                slot="reference"
                type="primary"
                class="edit-button"
                style="margin-left: 10px"
              >
                确定</el-button>
            </el-popconfirm>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getRoleRouter, updateMenu, addMenu } from '@/api/menu.js'
export default {
  name: 'RoleManagement',
  data() {
    return {
      showtabelData: [], // 展示的表单信息
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // loading
      routerProps: {
        label: 'label',
        children: 'children'
      },
      routerData: [],
      // 上级菜单
      routerOption: [],
      // 表单数据
      formData: {}
    }
  },
  mounted() {
    this.getMenuList()
  },
  methods: {
    // 获取路由表单信息
    getMenuList() {
      this.loading = true
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      getRoleRouter()
        .then((res) => {
          console.log(res, '0000')
          this.showtabelData = res
          res.map((item) => {
            if (item.menuType === 'M') {
              this.routerOption.push({
                id: item.id,
                label: item.menuName
              })
            }
          })
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 关闭弹窗
    handleClose() {
      this.formData = {}
    },
    // 打开编辑弹窗
    handleUpdate(row) {
      this.formData = { ...this.formData, ...row }
      this.Isedit = true
      this.edit_dialogVisible = true
    },
    // 打开添加弹窗
    add() {
      this.formData = {}
      this.Isedit = false
      this.edit_dialogVisible = true
    },
    // 更新信息
    submitForm() {
      // 编辑
      if (this.Isedit) {
        updateMenu(this.formData).then((res) => {
          this.$message.success('修改成功')
          this.edit_dialogVisible = false
          this.formData = {}
          this.getMenuList()
        })
      } else {
        addMenu(this.formData).then((res) => {
          this.$message.success('添加成功')
          this.edit_dialogVisible = false
          this.formData = {}
          this.getMenuList()
        })
      }
    }
  }
}
</script>
<style lang="scss">
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;

  .role_heard_tool {
    margin-bottom: 10px;
  }

  .edit_titile {
    .dialog_input {
      display: flex;
      align-items: center;
      // justify-content: space-around;
      width: 70%;

      .el-input {
        width: 70%;
      }
    }
  }

  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }

  .authority_info {
    margin-top: 25px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff;
    font-size: 26px;
    border: 1px solid #909399;
    border-radius: 25px;
    background: #c0c4cc;
    padding: 2px;
  }
}
</style>
